// extracted by mini-css-extract-plugin
export default {"hotkeyContainer":"Hotkeys_hotkeyContainer__JQUIN","key":"Hotkeys_key__EQj0N","description":"Hotkeys_description__bzZih"};